module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.hasDoc) ? _c('div', {
    staticClass: "twui-markbox",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "searchbox"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('m.input_key')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.toSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.$store.state.searchKey),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "searchKey", $$v)
      },
      expression: "$store.state.searchKey"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "twui-ico xsearch",
    on: {
      "click": _vm.toSearch
    }
  })], 1)]), _vm._v(" "), _c('h2', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.doc.docTitle))]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.$t('m.update_time')) + "：" + _vm._s(_vm.doc.lastModifyTime))]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [(_vm.$store.state.typeOfAppList.length === 0 && _vm.$store.state.isAdmin && !_vm.editor.isEditing) ? _c('a', {
    on: {
      "click": _vm.editorDoc
    }
  }, [_c('i', {
    staticClass: "twui-ico xedit"
  }), _vm._v("\n        " + _vm._s(_vm.$t('m.editor')) + "\n      ")]) : _c('div', {
    staticClass: "editcon"
  }, [(_vm.$store.state.isAdmin && _vm.editor.isEditing) ? _c('div', {
    staticClass: "twui-ico xtips"
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.$t('m.support_file_type_info')))])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.isAdmin && _vm.editor.isEditing) ? _c('el-upload', {
    staticClass: "xuploadbtn",
    attrs: {
      "action": _vm.file_upload_server,
      "headers": _vm.headerObj,
      "data": _vm.uploadData,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadFail,
      "before-upload": _vm.beforeUpload,
      "show-file-list": false,
      "accept": _vm.fileType
    }
  }, [_c('button', {
    staticClass: "twui-btn xborder"
  }, [_vm._v(_vm._s(_vm.$t('m.upload_file')))])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.isAdmin && _vm.editor.isEditing) ? _c('button', {
    staticClass: "twui-btn xborder",
    on: {
      "click": _vm.cancelSave
    }
  }, [_vm._v(_vm._s(_vm.$t('m.cancle')))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.isAdmin && _vm.editor.isEditing) ? _c('button', {
    staticClass: "twui-btn xmain",
    on: {
      "click": _vm.saveDoc
    }
  }, [_vm._v(_vm._s(_vm.$t('m.save')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [(!_vm.editor.isEditing) ? _c('tw-markdown-view', {
    ref: "markdownView"
  }) : _vm._e(), _vm._v(" "), (_vm.editor.isEditing) ? _c('tw-markdown-editor', {
    ref: "markdown"
  }) : _vm._e()], 1)]) : _c('div', [_c('div', {
    staticClass: "nodata-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/nodata.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('m.zwwd')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-777a8adc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/web/doc/component.vue
// module id = 597
// module chunks = 1